module.exports = __webpack_public_path__ + "static/media/mouthShrugUpper.fd9f5966.obj";